import Vue from 'vue'
import '../carousel-swiper/carousel-swiper.vue'

export default el => new Vue({
  name: 'Results',
  el,
})